import { render, staticRenderFns } from "./TheProductDetailsStockAlert.vue?vue&type=template&id=5f3cbf5d&"
import script from "./TheProductDetailsStockAlert.vue?vue&type=script&lang=js&"
export * from "./TheProductDetailsStockAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/salesforce/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f3cbf5d')) {
      api.createRecord('5f3cbf5d', component.options)
    } else {
      api.reload('5f3cbf5d', component.options)
    }
    module.hot.accept("./TheProductDetailsStockAlert.vue?vue&type=template&id=5f3cbf5d&", function () {
      api.rerender('5f3cbf5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/TheProductDetailsStockAlert.vue"
export default component.exports